import Divider from 'components/Divider'
import { DescriptionType } from 'config/FAQ/type'
import Collapse from './component/Collapse'

interface Props {
    detail: DescriptionType[]
}
const DescriptionCollaspe: React.FC<Props> = ({ detail }) => {
    const count = detail?.length
    return (
        <>
            {detail?.map((dt, index) => {
                return (
                    <Collapse item={dt} isShowDivider={index < count} />
                )
            })}
        </>
    )
}
export default DescriptionCollaspe
